import * as React from "react";
const InHouseQASVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={68}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.03}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={30}
    />
    <path
      fill="#EF4136"
      d="M46.233 30.852c-.472-.492-.96-1-1.143-1.446-.17-.409-.18-1.086-.19-1.742-.019-1.22-.039-2.603-1-3.564-.961-.961-2.344-.981-3.564-1-.656-.01-1.334-.02-1.742-.19-.445-.184-.954-.671-1.447-1.143C36.285 20.94 35.306 20 34 20c-1.305 0-2.284.939-3.148 1.767-.492.472-1 .96-1.446 1.143-.406.17-1.086.18-1.742.19-1.22.019-2.603.039-3.564 1-.961.961-.975 2.344-1 3.564-.01.656-.02 1.333-.19 1.742-.184.445-.671.954-1.143 1.447C20.94 31.714 20 32.694 20 34c0 1.305.939 2.284 1.767 3.148.472.492.96 1 1.143 1.446.17.408.18 1.086.19 1.742.019 1.22.039 2.603 1 3.564.961.961 2.344.981 3.564 1 .656.01 1.333.02 1.742.19.445.184.954.671 1.447 1.142C31.714 47.063 32.694 48 34 48c1.305 0 2.284-.939 3.148-1.767.492-.472 1-.96 1.446-1.143.408-.17 1.086-.18 1.742-.19 1.22-.019 2.603-.039 3.564-1 .961-.961.981-2.344 1-3.564.01-.656.02-1.334.19-1.742.184-.445.671-.954 1.142-1.447C47.063 36.285 48 35.306 48 34c0-1.305-.939-2.284-1.767-3.148Zm-1.444 4.912c-.599.625-1.219 1.271-1.548 2.065-.315.762-.328 1.633-.341 2.477-.012.875-.026 1.791-.415 2.179-.389.388-1.299.403-2.179.415-.843.013-1.715.026-2.477.341-.794.329-1.44.949-2.065 1.548C35.139 45.388 34.5 46 34 46s-1.144-.615-1.764-1.211c-.62-.596-1.271-1.219-2.065-1.548-.762-.315-1.633-.328-2.477-.341-.875-.012-1.791-.026-2.179-.415-.387-.389-.402-1.299-.415-2.179-.013-.843-.026-1.715-.341-2.477-.329-.794-.949-1.44-1.548-2.065C22.613 35.139 22 34.5 22 34s.615-1.144 1.211-1.764c.597-.62 1.219-1.271 1.548-2.065.315-.762.328-1.633.341-2.477.012-.875.026-1.791.415-2.179.389-.387 1.299-.402 2.179-.415.844-.013 1.715-.026 2.477-.341.794-.329 1.44-.949 2.065-1.548C32.861 22.613 33.5 22 34 22s1.144.615 1.764 1.211c.62.597 1.271 1.219 2.065 1.548.762.315 1.633.328 2.477.341.875.012 1.791.026 2.179.415.388.389.403 1.299.415 2.179.013.844.026 1.715.341 2.477.329.794.949 1.44 1.548 2.065C45.388 32.861 46 33.5 46 34s-.615 1.144-1.211 1.764Zm-5.081-5.472a1.001 1.001 0 0 1 0 1.415l-7 7a1.001 1.001 0 0 1-1.415 0l-3-3a1 1 0 1 1 1.415-1.415L32 36.586l6.292-6.293a1.001 1.001 0 0 1 1.416 0Z"
    />
  </svg>
);
export default InHouseQASVG;
